import { IAlertContext } from "./Interfaces/IAlertContext";
import { AlertActionKeys, AlertActionUnion } from "./Alert.Actions";

export const INITIAL_STATE: IAlertContext = {
  isOpen: false,
  message: "",
  title: "",
};

export const AlertReducers = (
  state = INITIAL_STATE,
  action: AlertActionUnion
): IAlertContext => {
  switch (action.type) {
    case AlertActionKeys.SET_CLOSED:
      return {
        ...state,
        isOpen: false,
      };
    case AlertActionKeys.SET_OPEN:
      return {
        ...state,
        isOpen: true,
        message: action.payload.message,
        title: action.payload.title,
      };
    default:
      return state;
  }
};
